import { mainApiInstance } from "../_axiosInstance";

export enum ATSJobStatus {
  PROCESSING = "processing",
  COMPLETED = "completed",
  FAILED = "failed",
}

export interface GenerateATSResponse {
  jobId: string;
  status: ATSJobStatus;
}

export interface StatusATSResponse {
  jobId: string;
  status: ATSJobStatus;
  file_url: string;
}

export interface ATSResponse {
  jobId: string;
  file_url: string;
}

const normalizeATSJobStatus = (status: string): ATSJobStatus => {
  const normalized = status.toLowerCase();
  if (normalized === ATSJobStatus.COMPLETED) return ATSJobStatus.COMPLETED;
  if (normalized === ATSJobStatus.FAILED) return ATSJobStatus.FAILED;
  return ATSJobStatus.PROCESSING;
};

const generateATS = async (resumeId: string): Promise<GenerateATSResponse> => {
  const response = await mainApiInstance.post<GenerateATSResponse>(
    `/ats/generate`,
    {
      resume_id: resumeId,
    },
  );
  return {
    ...response.data,
    status: normalizeATSJobStatus(response.data.status),
  };
};

const checkStatusATS = async (jobId: string): Promise<StatusATSResponse> => {
  const response = await mainApiInstance.get<StatusATSResponse>(
    `/ats/${jobId}/status`,
  );
  return {
    ...response.data,
    status: normalizeATSJobStatus(response.data.status),
  };
};

const getATSByResumeId = async (resumeId: string): Promise<ATSResponse> => {
  const response = await mainApiInstance.get<ATSResponse>(`/ats/${resumeId}`);
  return response.data;
};

export const atsResumeService = {
  generateATS,
  checkStatusATS,
  getATSByResumeId,
};
